import * as React from 'react'
import { useTranslation } from 'react-i18next'

import TabLinks from '../ui/tabLinks'

import { TabLink } from '../../store/commonTypes'
import paths from '../../paths'

const NotificationsTabs: React.FunctionComponent = () => {
    const [t] = useTranslation()

    const links: TabLink[] = [
        {
            label: t('Notifications'),
            path: paths.notificationList.path
        },
        {
            label: t('Settings'),
            path: paths.notificationSettings.path
        }
    ]

    return <TabLinks links={links} />
}

export default NotificationsTabs
